import { render, staticRenderFns } from "./assignHomework.vue?vue&type=template&id=441446d5&scoped=true"
import script from "./assignHomework.vue?vue&type=script&lang=js"
export * from "./assignHomework.vue?vue&type=script&lang=js"
import style0 from "./assignHomework.vue?vue&type=style&index=0&id=441446d5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441446d5",
  null
  
)

export default component.exports